<template>
  <canvas width="160" height="200"></canvas>
</template>

<script>
export default {
  emits: ['update:bezier'],
  props: ['bezier'],
  mounted: function () {
    var self = this,
      canvas = this.$el,
      ctx = canvas.getContext('2d');

    // bezier contructor
    function BezierHandle(x, y) {
      this.x = x;
      this.y = y;
      this.width = 12;
      this.height = 12;
    }

    BezierHandle.prototype = {
      getSides: function () {
        this.left = this.x - this.width / 2;
        this.right = this.left + this.width;
        this.top = this.y - this.height / 2;
        this.bottom = this.top + this.height;
      },

      draw: function () {
        this.getSides();
        ctx.fillStyle = '#222';
        ctx.fillRect(this.left, this.top, this.width, this.height);
      },
    };

    // make 2 new handles
    var handles = [new BezierHandle(50, 175), new BezierHandle(150, 180)];

    function Graph() {
      this.x = 5;
      this.y = 25;
      this.height = 150;
      this.width = 150;
    }

    Graph.prototype = {
      draw: function () {
        ctx.save();

        ctx.fillStyle = '#fff';
        ctx.fillRect(this.x, this.y, this.width, this.height);

        // the 0.5 offset is to account for stroke width to make lines sharp
        ctx.strokeStyle = '#666';
        ctx.lineWidth = 1;
        ctx.strokeRect(this.x + 0.5, this.y - 0.5, this.width - 1, this.height);

        ctx.restore();
      },
    };

    var graph = new Graph();

    function getPos(event) {
      var offset = $(self.$el).offset();
      return {
        x: event.pageX - offset.left,
        y: event.pageY - offset.top,
      };
    }

    var drag = false,
      draggingObj,
      oldX,
      oldY;

    function onPress(event) {
      // to get rid of text cursor
      event.preventDefault();
      event.stopPropagation(); //not sure if this is needed

      var mouseCoordinates = getPos(event),
        x = mouseCoordinates.x,
        y = mouseCoordinates.y;

      //check to see if over any handles
      for (var i = 0; i < handles.length; i++) {
        var current = handles[i],
          curLeft = current.left,
          curRight = current.right,
          curTop = current.top,
          curBottom = current.bottom;

        if (x >= curLeft && x <= curRight && y >= curTop && y <= curBottom) {
          //over the current handle
          //drag = true;
          draggingObj = current;
          oldX = event.pageX;
          oldY = event.pageY;

          document.addEventListener('mouseup', onRelease, false);
          document.addEventListener('mousemove', onMove, false);

          // set move cursor
          document.body.style.cursor = canvas.style.cursor = 'move';
        }
      }
    }

    function onMove(event) {
      var offset = $(self.$el).offset(),
        x = event.pageX - offset.left,
        y = event.pageY - offset.top;

      if (x > graph.width) {
        x = graph.width;
      }
      if (x < 0) {
        x = 0;
      }
      if (y > canvas.height) {
        y = canvas.height;
      }
      if (y < 0) {
        y = 0;
      }

      draggingObj.x = x;
      draggingObj.y = y;

      updateDrawing();
    }

    function onRelease(event) {
      drag = false;

      // restore pointer cursor
      canvas.style.cursor = 'pointer';
      document.body.style.cursor = 'default';

      document.removeEventListener('mousemove', onMove, false);
      document.removeEventListener('mouseup', onRelease, false);

      // output code
      var cp1 = handles[0],
        cp2 = handles[1],
        x1 = (cp1.x / graph.width).toFixed(3),
        y1 = ((graph.height + graph.y - cp1.y) / graph.height).toFixed(3),
        x2 = (cp2.x / graph.width).toFixed(3),
        y2 = ((graph.height + graph.y - cp2.y) / graph.height).toFixed(3),
        points = x1 + ', ' + y1 + ', ' + x2 + ', ' + y2;

      self.$emit('update:bezier', points);
    }

    canvas.addEventListener('mousedown', onPress, false);

    function updateDrawing() {
      // clear
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // draw graph
      graph.draw();

      // get handles
      var cp1 = handles[0],
        cp2 = handles[1];

      // draw bezier curve
      ctx.save();
      ctx.strokeStyle = '#2bacca';
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(graph.x, graph.y + graph.height);
      //start at bottom left, first handle is cp1, second handle is cp2, end is top right
      ctx.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, graph.width, graph.y);
      ctx.stroke();
      ctx.restore();

      // draw anchor point lines
      ctx.strokeStyle = '#f00';
      ctx.beginPath();
      ctx.moveTo(graph.x, graph.y + graph.height);
      ctx.lineTo(cp1.x, cp1.y);
      ctx.moveTo(graph.width, graph.y);
      ctx.lineTo(cp2.x, cp2.y);
      ctx.stroke();

      // draw handles
      for (var i = 0; i < handles.length; i++) {
        handles[i].draw();
      }
    }

    function presetChange() {
      // `bezier` can be null before the element has been initialised.
      if (self.bezier) {
        var coordinates = self.bezier.split(','),
          cp1 = handles[0],
          cp2 = handles[1];

        cp1.x = coordinates[0] * graph.width;
        cp1.y = graph.y + graph.height - coordinates[1] * graph.height;
        cp2.x = coordinates[2] * graph.width;
        cp2.y = graph.y + graph.height - coordinates[3] * graph.height;
      }

      // Always draw, even when there is no preset yet, so the canvas and
      // handle bounds are initialised.
      updateDrawing();
    }

    // Allow the parent to update the preset after mount.
    this.presetChange = presetChange;
    presetChange();
  },

  watch: {
    bezier() {
      if (this.presetChange) {
        this.presetChange();
      }
    },
  },
};
</script>
